import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, "Error: " + _toDisplayString(_ctx.code) + " - " + _toDisplayString(_ctx.data.get(_ctx.code).title), 1),
    _createElementVNode("p", null, _toDisplayString(_ctx.data.get(_ctx.code).content), 1)
  ]))
}